import React, { FC, InputHTMLAttributes } from 'react'

import Layout, { LayoutProps } from '../../layouts/Layout'
import { SignatureCanvasProps } from '../../components/SignatureCanvas'
import { ActionButtonProps } from '../../components/ActionButton'

import * as SC from './styled'

export type DisclaimerTemplateProps = {
  className?: string
  layoutProps?: LayoutProps
  title?: string
  disclaimer: {
    text: string
  }
  checkbox: {
    input?: InputHTMLAttributes<HTMLInputElement>
    label: string
  }
  signatureLabel?: string
  signatureCanvas?: SignatureCanvasProps
  back?: {
    label: string
    onClick?: () => void
  }
  confirmButton: ActionButtonProps
}

const DisclaimerTemplate: FC<DisclaimerTemplateProps> = ({
  title,
  layoutProps,
  disclaimer,
  checkbox,
  signatureLabel,
  signatureCanvas,
  back,
  confirmButton,
}) => {
  return (
    <Layout {...layoutProps}>
      <SC.Content>
        <SC.Box>
          <SC.Title>{title}</SC.Title>
          <SC.DisclaimerText dangerouslySetInnerHTML={{ __html: disclaimer.text }} />
          <SC.SignatureLabel>{signatureLabel}</SC.SignatureLabel>
          <SC.CheckboxContainer>
            <SC.InputCheckbox {...checkbox.input} type="checkbox" />
            <SC.InputCheckboxCheckmark />
            {checkbox.label}
          </SC.CheckboxContainer>
          <SC.Signature {...signatureCanvas} />
          <SC.Buttons>
            {back && <SC.Back onClick={back.onClick}>{back.label}</SC.Back>}
            <SC.ConfirmButton {...confirmButton} />
          </SC.Buttons>
        </SC.Box>
      </SC.Content>
    </Layout>
  )
}

export default DisclaimerTemplate
